export const DEFAULT_COLOR_LINK = "#1155CC";
export const DEFAULT_VISITED_COLOR_LINK = "#551A8B";
export const DEFAULT_CHECKBOX_COLOR = "#fb972e";
